import React from 'react'
import PropTypes from 'prop-types'
import Drawer from '@material-ui/core/Drawer'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import './side-popover.scss'

function SidePopover({
  open,
  close,
  children,
  title,
  className,
  position,
  backDrop,
  appBar,
  ...restProps
}) {
  const getContent = () => {
    if (appBar) {
      return (
        <>
          <AppBar position="static">
            <Toolbar className="side-popover-header">
              <Typography variant="h5">{title}</Typography>
              <IconButton onClick={close}>
                <CloseIcon />
              </IconButton>
            </Toolbar>
          </AppBar>
          <div className="side-popover-content">{children}</div>
        </>
      )
    }

    return children
  }

  return (
    <Drawer
      {...restProps}
      open={open}
      onClose={close}
      anchor={position}
      className={`side-popover ${className}`}
      ModalProps={{
        BackdropProps: backDrop,
      }}>
      {getContent()}
    </Drawer>
  )
}

SidePopover.propTypes = {
  open: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  title: PropTypes.string,
  className: PropTypes.string,
  position: PropTypes.string,
}

SidePopover.defaultProps = {
  position: 'right',
}

export default SidePopover
